import { AuthWebClient } from '@skelloapp/skello-auth-client';
import { VUE_APP_SKELLO_API_URL } from '@/shared/config';

class AuthClient {
  constructor() {
    this.authClient = new AuthWebClient({
      baseURL: VUE_APP_SKELLO_API_URL,
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
        'X-Source-Client': 'skelloOnboarding:web',
      },
    });
  }

  async login({ email, password }) {
    const data = await this.authClient.login({ email, password, rememberMe: false });

    return data;
  }
}

export const authClient = new AuthClient();
